import { __awaiter } from "tslib";
import { useDispatch } from 'react-redux';
import { useOrderQuery, useCancelOrderMutation } from '@websky/graphql';
import { fillOrder } from '../../../../Checkout/store/order/actions';
export function useCancelOrder() {
    const dispatch = useDispatch();
    const { refetch: getOrder } = useOrderQuery({ skip: true });
    const [cancelOrder, cancelOrderResult] = useCancelOrderMutation();
    const onCancelOrder = ({ id }) => __awaiter(this, void 0, void 0, function* () {
        let order;
        try {
            const { data } = yield cancelOrder({ variables: { id } });
            if (data === null || data === void 0 ? void 0 : data.CancelOrder) {
                order = data.CancelOrder;
            }
        }
        catch (_a) {
            const { data } = yield getOrder({ id });
            if (data.Order) {
                order = data.Order;
            }
        }
        finally {
            dispatch(fillOrder(order));
        }
    });
    return { onCancelOrder, cancelOrderResult };
}
